<template>
  <div class="py-8">
    <div
      v-if="showLoading"
      wire:loading
      class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center"
    >
      <div
        class="loader ease-linear rounded-full border-4 border-t-4 border-gray-200 h-12 w-12 mb-4"
      ></div>
      <h2 class="text-center text-white text-xl font-semibold">Loading...</h2>
    </div>

    <v-sheet class="mx-auto">
      <v-slide-group elevation="10">
        <v-slide-item v-for="rental in newH" :key="rental.id">
          <div>
            <v-hover v-slot:default="{ hover }">
              <v-card
                class="shadow ma-4"
                min-height="380"
                width="370"
                color="grey lighten-4"
              >
                <div v-if="hover && rental.Reviews"></div>
                <div v-else class="corner-ribbon top-left sticky red shadow">
                  Sold By: {{ rental.ListOfficeName }} <br />
                  Agent: {{ rental.ListAgentFullName }}
                </div>
                <v-img :aspect-ratio="16 / 9" :src="rental.Images[0]">
                  <v-expand-transition v-if="rental.Reviews">
                    <div
                      v-if="hover"
                      class="d-flex transition-fast-in-fast-out black darken-2 v-card--reveal display-3 white--text"
                      style="height: 100%; opacity: .7"
                    >
                      <blockquote
                        v-for="review in rental.Reviews"
                        :key="review.id"
                      >
                        <div class="p-4">
                          <svg
                            class="h-12 w-12 text-white opacity-25"
                            fill="currentColor"
                            viewBox="0 0 32 32"
                            aria-hidden="true"
                          >
                            <path
                              d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                            />
                          </svg>
                          <p class="mt-6 text-2xl font-medium text-white">
                            {{ review.review }}
                          </p>
                        </div>
                        <footer class="mt-6 p-4">
                          <p class="text-base font-medium text-white">
                            {{ review.name }}
                          </p>
                          <!-- <p class="text-base font-medium text-indigo-100">CEO at PureInsights</p> -->
                        </footer>
                      </blockquote>
                    </div>
                  </v-expand-transition>
                </v-img>

                <v-card-text class="text-center">
                  <h3
                    class="display-1 font-weight-light blue--text mb-2 text-center"
                  >
                    {{ rental.StreetNumber }}
                    {{ rental.StreetName }}
                    {{ rental.StreetSuffix }}
                  </h3>
                  <v-divider></v-divider>

                  <v-chip class="mt-2"
                    ><i class="m-1 text-secondary fas fa-align-justify"></i
                    ><b class="mr-1">Square Feet: </b>
                    {{ rental.LivingAreaRange }}
                  </v-chip>
                </v-card-text>
              </v-card>
            </v-hover>
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
export default {
  props: { status: Boolean },
  data: () => ({
    home: "home",
    displayModal: false,
    showMessage: false,
    loading: false,
    search: "",
    price: "",
    bed: "",
    bath: "",
    newH: [],
    showLoading: true
  }),

  created() {
    this.newHomes();
  },

  methods: {
    redirectRental() {
      this.$router.push({ name: "rentals" });
    },

    openModal() {
      if (!sessionStorage.getItem("modal")) {
        this.displayModal = true;
      } else {
        this.redirectListing();
      }
    },

    redirectListing() {
      this.displayModal = false;
      this.$router.push({ name: "listings" });
    },

    register() {
      this.$router.push({ name: "Register" });
    },

    newHomes() {
      window.axios.get("/api/getHBhouses").then(response => {
        this.newH = response.data;
        this.showLoading = false;
        this.$emit("clicked");
      });
    },

    singleView(rental) {
      this.$router.push({
        name: "SingleIDX",
        params: { id: rental.ListingKeyNumeric, rental }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.pulse-button {
  box-shadow: 0 0 0 rgba(14, 118, 170, 0.7);
  -webkit-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -moz-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  -ms-animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
  animation: pulse 1.25s infinite cubic-bezier(0.66, 0, 0, 1);
}
.pulse-button:hover {
  -webkit-animation: none;
  -moz-animation: none;
  -ms-animation: none;
  animation: none;
}

@-webkit-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@-moz-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@-ms-keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}
@keyframes pulse {
  to {
    box-shadow: 0 0 0 45px rgba(232, 76, 61, 0);
  }
}

.container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  padding: 4px 16px;
}

#cards-container {
  overflow: hidden;
  margin: 20px;
}

.cards {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 99999px;
}

.card {
  /* Add shadows to create the "card" effect */
  -webkit-box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  width: 235px;
  margin: 15px 7.5px;
}

.card:hover {
  -webkit-box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  cursor: pointer;
}

.card .img {
  max-width: 220px;
  height: 220px;
  display: inline-block;
}

#slide-left-container,
#slide-right-container {
  display: none;
}

#slide-left-container.active,
#slide-right-container.active {
  display: block;
  cursor: pointer;
}

.slide-left,
.slide-right {
  border-color: #fff;
  border-style: solid;
  height: 20px;
  width: 20px;
  margin-top: 30%;
}

.slide-left {
  border-width: 4px 0 0 4px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  margin-left: 40%;
}

.slide-right {
  border-width: 4px 4px 0 0;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  margin-left: 22%;
}

.corner-ribbon {
  z-index: 5;
  width: 400px;
  background: #e43;
  position: absolute;
  top: 25px;
  left: -50px;
  text-align: center;
  line-height: 25px;
  letter-spacing: 1px;
  color: #f0f0f0;
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.corner-ribbon.top-left {
  top: 95px;
  left: -18px;
  transform: rotate(-30deg);
  -webkit-transform: rotate(-30deg);
}
</style>
